var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "camera_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 43h36a4 4 0 004-4V15a4 4 0 00-4-4h-7l-4-7H19l-4 7H6a4 4 0 00-4 4v24a4 4 0 004 4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 27,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 18,
    r: 1
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+Y2FtZXJhPC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cGF0aCBkPSJNNiw0M0g0MmE0LDQsMCwwLDAsNC00VjE1YTQsNCwwLDAsMC00LTRIMzVMMzEsNEgxOWwtNCw3SDZhNCw0LDAsMCwwLTQsNFYzOUE0LDQsMCwwLDAsNiw0M1oiPjwvcGF0aD48Y2lyY2xlIGN4PSIyNSIgY3k9IjI3IiByPSIxMCIgc3Ryb2tlPSIjMjcyNzI2Ij48L2NpcmNsZT48Y2lyY2xlIGN4PSI5IiBjeT0iMTgiIHI9IjEiIHN0cm9rZT0iIzI3MjcyNiI+PC9jaXJjbGU+PC9nPjwvc3ZnPg==";
export { SvgCamera as ReactComponent };